import MagicGlow from './MagicGlow'

export default MagicGlow
